import moment from 'moment'
import React from 'react'

const InvoicePDF = ({ cusField, showPreview, invoiceList }) => {

    const getTotal = () => {
        const totalList = invoiceList.map((val) => {
            return (val.qty ? val.qty : 1) * val.price
        })

        let sum = 0
        totalList.forEach(x => sum += x);
        return sum
    }

    return (
        <div className='mt-[20px] shadow-shadow100 p-[25px_24px] select-none'>
            <div className='flex justify-between items-center'>
                <h1 className='text-[20px] font-[500]'>Invoice</h1>
                <p className='text-[#9b9b9b] text-[20px] font-[500]'>abc</p>
            </div>
            <div className='text-[10px] font-[500] mt-[14px]'>
                <div className='flex'>
                    <p className='w-[80px]'>Invoice number</p>
                    <p>{cusField.invoice_items_id}</p>
                </div>
                <div className='flex'>
                    <p className='w-[80px]'>Date Due</p>
                    <p>{moment(Date()).format("MMMM DD, yyyy")}</p>
                </div>
            </div>
            <div className='mt-[18px] text-[10px] flex'>
                <p className='w-[45%]'>abc</p>
                <div className='w-[55%]'>
                    <p className='font-[500]'>Bill to</p>
                    <p>{cusField.name}</p>
                    <p>{cusField.account_email}</p>
                </div>
            </div>
            <h1 className='text-[16px] font-[500] my-[20px]'>
                ${!showPreview ? '0.00' : getTotal()} {moment(Date()).format("MMMM DD, yyyy")}</h1>
            <table className='w-full text-[10px]'>
                <thead>
                    <th className='text-start font-normal border-b-[1px] border-b-[#aaa] pb-[4px] sm:w-[234px]'>Description</th>
                    <th className='text-start font-normal border-b-[1px] border-b-[#aaa] pb-[4px]'>Qty</th>
                    <th className='text-start font-normal border-b-[1px] border-b-[#aaa] pb-[4px]'>Unit prize</th>
                    <th className='text-end font-normal border-b-[1px] border-b-[#aaa] pb-[4px]'>Amount</th>
                </thead>
                <tbody>
                    {showPreview &&
                        invoiceList.map((val, i) =>
                            <tr key={i}>
                                <td className='text-start font-normal pb-[20px] w-[234px]'>{val.item}</td>
                                <td className='text-start font-normal border-b-[1px] pb-[20px]'>{val.qty}</td>
                                <td className='text-start font-normal border-b-[1px] pb-[20px]'>{val.price}</td>
                                <td className='text-end font-normal border-b-[1px] pb-[20px]'>${val.price * (val.qty ? val.qty : 1)}</td>
                            </tr>
                        )}
                    <tr>
                        <td className='py-1'></td>
                        <td className='py-1 border-b-[1px] border-b-[#aaa3]'>Subtotal</td>
                        <td className='py-1 border-b-[1px] border-b-[#aaa3]'></td>
                        <td className='text-end py-1 border-b-[1px] border-b-[#aaa3]'>${!showPreview ? '0.00' : getTotal()}</td>
                    </tr>
                    <tr>
                        <td className='py-1'></td>
                        <td className='py-1 border-b-[1px] border-b-[#aaa3]'>Total</td>
                        <td className='py-1 border-b-[1px] border-b-[#aaa3]'></td>
                        <td className='text-end py-1 border-b-[1px] border-b-[#aaa3]'>${!showPreview ? '0.00' : getTotal()}</td>
                    </tr>
                    <tr>
                        <td className='py-1'></td>
                        <td className='font-[600] py-1'>Amount due</td>
                        <td className='py-1'></td>
                        <td className='text-end font-[600] py-1'>${!showPreview ? '0.00' : getTotal()}</td>
                    </tr>
                </tbody>
            </table>
            <p className='pt-[20px] border-t-[1px] border-t-[#aaa3] text-[10px] mt-[300px] mb-[60px]'>{cusField.invoice_items_id} -
                ${!showPreview ? '0.00' : getTotal()} {moment(Date()).format("MMMM DD, yyyy")}</p>
        </div>
    )
}

export default InvoicePDF